import React, { useState, useCallback, useEffect } from "react";
import { useIntegrations } from "./hooks/useIntegrations";
import IntegrationSidebar from "./components/IntegrationSidebar";
import IntegrationDetail from "./components/IntegrationDetail";
import { MasterDetailLayout, ContentLoader, Breadcrumb } from "../../../components/Common";
import { INTEGRATION_PROVIDERS } from "./constants";

/**
 * IntegrationsPage
 * Rota: /settings/integrations
 * Layout Master-Detail: Sidebar com providers + Painel de configuração e teste.
 */
const IntegrationsPage = () => {
    document.title = "Integrações | NeoApp";

    const [activeProviderId, setActiveProviderId] = useState(
        INTEGRATION_PROVIDERS[0]?.id || ""
    );

    const {
        integrations,
        isLoading,
        isSaving,
        isTesting,
        testResult,
        evolutionStatus,
        getProviderConfig,
        handleSave,
        handleTest,
        clearTestResult,
        setActiveProvider,
        isReady,
    } = useIntegrations();

    const handleSelect = useCallback((providerId) => {
        setActiveProviderId(providerId);
        setActiveProvider(providerId);
    }, [setActiveProvider]);

    // Iniciar polling na montagem se o provider inicial for evolution
    useEffect(() => {
        if (isReady) setActiveProvider(activeProviderId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isReady]);

    if (!isReady) {
        return <ContentLoader message="Carregando Integrações..." />;
    }

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Integrações" />
            </div>
            
            <div className="border-top mb-3"></div>
            <MasterDetailLayout
                master={
                    <IntegrationSidebar
                        integrations={integrations}
                        activeProviderId={activeProviderId}
                        onSelect={handleSelect}
                        loading={isLoading}
                        evolutionStatus={evolutionStatus}
                    />
                }
                detail={
                    <IntegrationDetail
                        providerId={activeProviderId}
                        providerData={getProviderConfig(activeProviderId)}
                        onSave={handleSave}
                        isSaving={isSaving}
                        onTest={handleTest}
                        isTesting={isTesting}
                        testResult={testResult}
                        onClearTest={clearTestResult}
                        evolutionStatus={evolutionStatus}
                    />
                }
            />
        </React.Fragment>
    );
};

export default IntegrationsPage;
